const GIT_COMMIT_SHA_PATTERN = /^[0-9a-f]{7,64}$/i;

/**
 * Return a bounded release identifier that is safe to use as an analytics
 * dimension. An absent property identifies bundles from before release
 * attribution existed; "unknown" identifies a current bundle whose build
 * environment did not provide a usable Git SHA.
 */
export function normalizeFrontendRelease(rawRelease: unknown): string {
  if (typeof rawRelease !== "string") return "unknown";

  const normalizedRelease = rawRelease.trim().toLowerCase();
  return GIT_COMMIT_SHA_PATTERN.test(normalizedRelease) ? normalizedRelease : "unknown";
}

export function getFrontendRelease(): string {
  return normalizeFrontendRelease(import.meta.env.VITE_GIT_SHA);
}
